"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
exports.Attachment = react_1.default.memo(function (_a) {
    var color = _a.color;
    return ((0, jsx_runtime_1.jsx)("path", { d: "M11.001 4.5v7.053c0 1.394-1.02 2.634-2.406 2.767a2.662 2.662 0 0 1-2.927-2.653v-8.24c0-.874.627-1.667 1.493-1.754 1-.1 1.84.68 1.84 1.66v7c0 .367-.3.667-.666.667a.669.669 0 0 1-.667-.667V4.5c0-.273-.227-.5-.5-.5s-.5.227-.5.5v5.74c0 .873.627 1.667 1.493 1.753 1 .1 1.84-.68 1.84-1.66V3.447c0-1.394-1.02-2.634-2.406-2.767a2.666 2.666 0 0 0-2.927 2.653v8.18c0 1.914 1.4 3.627 3.307 3.807A3.67 3.67 0 0 0 12 11.667V4.5c0-.273-.226-.5-.5-.5-.273 0-.5.227-.5.5z", fill: color }));
});
